import React, { useState } from "react";
import { Link, useParams } from "react-router-dom";
import DashboardWrapper from "./DashboardWrapper";
import { BiHome, BiCloudUpload, BiEdit, BiTrash } from "react-icons/bi";
// import { FormControlLabel, List, ListItem, Switch } from "@mui/material";
import {
  Switch,
  List,
  ListItem,
  FormControlLabel,
  Button,
} from "@material-ui/core";
import { MdFeedback, MdLogout } from "react-icons/md";
import Auth from "../Auth";
const menus = [
  // { to: "home", title: "Home", icon: <BiHome className="icon me-2" /> },
  {
    to: "create",
    title: "Create",
    icon: <BiCloudUpload className="icon me-2" />,
  },
  { to: "update", title: "Update", icon: <BiEdit className="icon me-2" /> },
  {
    to: "feedback",
    title: "Feedback",
    icon: <MdFeedback className="icon me-2" />,
  },
];

const Dashboard = ({ children, history }) => {
  const { menu } = useParams();

  const [show, setShow] = useState(true);

  return (
    <DashboardWrapper>
      <div className={`sidebar ${(show && "show") || "hide"}`}>
        <h1 className="side-title">Tahlil24</h1>
        <hr className="bg-white" />
        <List component="nav" className="position-relative">
          {menus.map((v, i) => (
            <li key={i}>
              <Link
                to={`/koinot/${v.to}`}
                className={`${menu === v.to ? "active" : ""}`}
              >
                <ListItem button>
                  {v.icon}
                  <span className="dash-title">{v.title}</span>
                </ListItem>
              </Link>
            </li>
          ))}
          <li className="logout">
            <a href="/" className="my-3 ">
              <ListItem button>
                <MdLogout className="icon me-2" />
                <span
                  className="dash-title"
                  onClick={() => {
                    localStorage.clear();
                    Auth.logout(() => {
                      history.push("/");
                    });
                  }}
                >
                  Log out
                </span>
              </ListItem>
            </a>
          </li>
        </List>
      </div>
      <div className="rightside">
        <header className="shadow">
          <FormControlLabel
            control={
              <Switch
                checked={!show}
                onChange={() => setShow(!show)}
                color="primary"
              />
            }
          />
        </header>
        <div className="content">{children}</div>
      </div>
    </DashboardWrapper>
  );
};

export default Dashboard;



// WEBPACK FOOTER //
// ./src/Container/index.js